export const formatCurrency = value => value !== undefined ? ((value < 0 ? '-' : '') + '$' + Math.abs(value.toFixed(2))) : 0;

export const addDashIfZero = value => value === 0 ? '-' : formatCurrency(value);

export const addLeftZeros = value => (
  value ?
    value.toString().padStart((5 - value.toString().length), '0') :
    ''
);




// WEBPACK FOOTER //
// ./src/shared/helpers/dataFormatHelper.js